export const GENDER_OPTIONS = {
  1: { label: `Male`, id: "1", value: "1" },
  2: { label: `Female`, id: "2", value: "2" },
};
